import { GlobalStyles } from '@mui/material'
import React from 'react'

const GlobalStylesComponent = () => {
    return (
        <GlobalStyles
            styles={(theme) => ({
                ':root': {
                    /* Palette */
                    '--background-default': theme.palette.background.default,
                    '--background-paper': theme.palette.background.paper,
                    '--text-primary': theme.palette.text.primary,
                    '--text-secondary': theme.palette.text.secondary,
                    '--text-grayText': theme.palette.text.grayText,
                    '--text-label': theme.palette.text.label,
                    '--text-white': theme.palette.text.white,
                    '--primary-main': theme.palette.primary.main,
                    '--secondary-main': theme.palette.secondary.main,
                    '--lightgray-main': theme.palette.lightgray.main,
                    '--red-main': theme.palette.red.main,
                    '--drawer-menu-item-main': theme.palette.drawermenuitem.main,
                    '--typography-label-main': theme.palette.typographyLabel.main,
                    '--light-grey-main': theme.palette.lightgrey.main,
                    '--dark-background': theme.palette.background.darkBackground,
                },
            })}
        />
    )
}

export default GlobalStylesComponent
